var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('base-document',{key:_vm.documentId,attrs:{"project-id":_vm.projectId,"document-id":_vm.documentId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }